"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const sumBy_1 = tslib_1.__importDefault(require("lodash/sumBy"));
const getContentType_1 = require("../helpers/getContentType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
// import { getTimeSpentEvent } from 'helpers/getEvent/getTimeSpentEvent';
/**
 * Updates timeSpent on nonLeaftNodes.
 */
function updateTimeSpent(command, user, content, states) {
    const events = [];
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const currentTimeSpent = state.timeSpent;
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE: {
            const childrenStates = getState_1.getChildrenStatesForContentByUserId(states, content, user.userId);
            state.timeSpent = sumBy_1.default(childrenStates, s => s.timeSpent || 0);
            break;
        }
        case entity_1.ContentType.CURRICULUM: {
            const childrenContents = content.offers;
            const childrenContentIds = childrenContents.map(c => c.offerId);
            const childrenStates = getState_1.getStatesForUserIdAndContentIds(states, childrenContentIds, user.userId);
            state.timeSpent = sumBy_1.default(childrenStates, s => s.timeSpent || 0);
            break;
        }
        default:
            break;
    }
    if (currentTimeSpent !== state.timeSpent) {
        state.lastUpdatedTimeSpent = command.timeStamp;
    }
    return events;
}
exports.updateTimeSpent = updateTimeSpent;
//# sourceMappingURL=updateTimeSpent.js.map